import { render, staticRenderFns } from "./LegalStatusModal.vue?vue&type=template&id=0a22fd78&scoped=true"
import script from "./LegalStatusModal.vue?vue&type=script&lang=js"
export * from "./LegalStatusModal.vue?vue&type=script&lang=js"
import style0 from "./LegalStatusModal.vue?vue&type=style&index=0&id=0a22fd78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22fd78",
  null
  
)

export default component.exports